<template>
  <svg xmlns="http://www.w3.org/2000/svg">
    <path
      d="m16.5 3.5h-2c-1.1 0-2 .9-2 2v5c0 1.1.9 2 2 2h2c1.1 0 2-.9 2-2v-5c0-1.1-.9-2-2-2zm0 7h-2v-5h2zm-6.5 5h8.5v2h-8.51c-.88 0-1.66-.58-1.92-1.43l-2.57-8.57v-4h2v4zm-1.5 3h10v2h-10z"
    />
  </svg>
</template>
